import s2 from "../assets/pictures/home/grid2.jpeg";
import v1 from "../assets/videos/home55.webm";
import Call from "../components/Call";
import DesktopWa from "../components/DesktopWa";
import { cls } from "../components/Utility";

export default function Dubai() {
  return (
    <>
      <div className="w-full bg-[#f8f8f6] pb-[105px]"></div>
      <p className="text-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 xl:text-[35px] text-[25px] font-[Headings] font-bold tracking-wider mt-[30px] mb-[25px]">
        JACK & JANE
      </p>
      <p className="mb-[50px] text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px] ">
        In the heart of the golden desert and the soul of a city that never
        sleeps, we brought a love story to life with the majestic skyline of
        Dubai as our canvas. From sunrise silhouettes by the Burj Khalifa to
        golden hour magic in the sweeping dunes, every frame was crafted with
        vision and soul.
        <br />
        <br /> We didn’t just shoot a pre-wedding—we designed a cinematic
        experience, where each moment unfolded like a scene from a timeless
        film. The couple’s story flowed through modern architecture, opulent
        yachts, and quiet beachside embraces. Our team used light, composition,
        and color to capture raw emotions in surreal settings. We played with
        reflections, drone perspectives, and dramatic lighting to elevate every
        shot. <br />
        <br />
        Each location was handpicked to reflect their bond—bold, dreamy, and
        grand. Every frame was art-directed with a balance of glamour and grace.
        This wasn’t just a photoshoot in Dubai; it was a visual poem stitched
        with love, legacy, and luxury.
      </p>

      <div className="flex flex-col xl:flex-row xl:justify-center xl:items-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 gap-[20px] mb-[40px]">
        <img
          src={s2}
          className="xl:w-[600px] xl:h-[800px] w-full h-[500px] object-cover"
        />

        <video
          className="xl:w-[600px] w-full xl:h-[800px] h-[500px] object-cover"
          autoPlay
          loop
          muted
        >
          <source src={v1} type="video/mp4" />
        </video>
      </div>
      <p className="mb-[50px] text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px] ">
        We capture love not just with cameras, but with vision blending
        cinematic storytelling, perfect lighting, and intentional frames. Every
        shot is composed like a scene from a film, where emotion leads and
        aesthetics follow. It’s not just photography; it’s visual storytelling
        crafted to feel, not just see.
      </p>
      <div
        className={cls(
          "flex flex-col gap-[10px] pl-[20px] pr-[20px] mb-[40px]",
          "xl:flex xl:flex-row xl:justify-center xl:gap-[10px] "
        )}
      >
        <img
          src={s2}
          className="xl:w-[370px] xl:h-[580px] w-full h-[400px] object-cover"
        />
        <img
          src={s2}
          className="xl:w-[370px] xl:h-[580px] w-full h-[400px] object-cover"
        />
        <img
          src={s2}
          className="xl:w-[370px] xl:h-[580px] w-full h-[400px] object-cover"
        />
      </div>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9353624245" />
      </div>
    </>
  );
}
